import React from 'react';
import { motion } from 'framer-motion';

const ToriiGateDivider = () => {
  return (
    <div className="relative w-full h-32 flex items-center justify-center overflow-hidden">
      {/* Wave pattern (seigaiha) */}
      <svg className="absolute inset-0 w-full h-full opacity-5" preserveAspectRatio="none">
        <defs>
          <pattern id="seigaiha" x="0" y="0" width="40" height="20" patternUnits="userSpaceOnUse">
            <path d="M0 10 Q10 0 20 10 T40 10" stroke="#D4A574" strokeWidth="0.5" fill="none" />
            <path d="M0 15 Q10 5 20 15 T40 15" stroke="#D4A574" strokeWidth="0.5" fill="none" opacity="0.6" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#seigaiha)" />
      </svg>

      {/* Torii Gate */}
      <motion.svg
        className="relative z-10"
        width="200"
        height="80"
        viewBox="0 0 200 80"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Main pillars */}
        <rect x="30" y="20" width="8" height="60" fill="#8B0000" opacity="0.6" />
        <rect x="162" y="20" width="8" height="60" fill="#8B0000" opacity="0.6" />
        
        {/* Top horizontal beam (kasagi) */}
        <motion.rect
          x="15"
          y="18"
          width="170"
          height="8"
          fill="#8B0000"
          opacity="0.8"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        />
        
        {/* Second horizontal beam (nuki) */}
        <motion.rect
          x="20"
          y="35"
          width="160"
          height="6"
          fill="#D4A574"
          opacity="0.6"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        />
        
        {/* Decorative end caps */}
        <circle cx="15" cy="22" r="4" fill="#D4A574" opacity="0.8" />
        <circle cx="185" cy="22" r="4" fill="#D4A574" opacity="0.8" />
      </motion.svg>

      {/* Enso circle accent */}
      <motion.div
        className="absolute right-20 top-1/2 -translate-y-1/2 w-16 h-16 border border-amber-900/20 rounded-full"
        initial={{ opacity: 0, rotate: 0 }}
        whileInView={{ opacity: 1, rotate: 360 }}
        viewport={{ once: true }}
        transition={{ duration: 2, ease: 'linear' }}
      />
    </div>
  );
};

export default ToriiGateDivider;
